module.exports = __webpack_public_path__ + "static/media/eventCallback_active.989d89f9.svg";